module.exports = __webpack_public_path__ + "statics/img/8.984d254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/8.png
// module id = oftx
// module chunks = 1